import * as ReactQuery from "@tanstack/react-query";
import * as React from "react";
import * as ReactDOM from "react-dom";
import * as ReactDOMClient from "react-dom/client";

declare global {
	// eslint-disable-next-line @typescript-eslint/consistent-type-definitions
	interface Window {
		RootreeVendor: {
			React: typeof React;
			ReactDOM: typeof ReactDOM;
			ReactDOMClient: typeof ReactDOMClient;
			ReactQuery: typeof ReactQuery;
		};
	}
}

window.RootreeVendor = { React, ReactDOM, ReactDOMClient, ReactQuery };
